@if (conceptForm.configuredVisibility) {
  <div class="concept-form">
    @if(!public && conceptForm.concept?.conceptObjectId && conceptForm.concept?.processStates && skin !== 'icam-red'){
      <states-process
        [type]="'processConcept'"
        [typeView]="'normal'"
        [concept]="conceptForm.concept"
        [item]="conceptForm.concept"
        [userPublic]="conceptForm.userPublic"
        (changeResponsible)="changeResponsible($event)"
        (changeLockedEdit)="changeLockedEdit($event)">
      </states-process>
    }
    <div [ngClass]="conceptForm.concept?.poll || conceptForm.concept?.publicLite || conceptForm.designViewLanding === 2 ? 'concept-form__main-container' : 'landing-page__form-container'">
      @if (conceptForm.concept?.conceptObjectId !== 'view' && !conceptForm.concept?.poll && !conceptForm.concept?.publicLite && conceptForm.designViewLanding !== 2) {
        <div class="concept-form__side-panels-landing">
          @if (conceptForm.concept?.references?.length) {
            <concept-legal-documentation
              [referencesList]="conceptForm.concept?.references"
              [concept]="conceptForm.concept">
            </concept-legal-documentation>
          }
          @if (conceptForm.concept?.conceptObjectId && conceptForm.icamConceptObject && conceptForm.concept?.processStates) {
            <box-query-state
              [concept]="conceptForm.concept">
            </box-query-state>
          }
          @if (isMonitoring && conceptForm.productTypeId !== 4 && !conceptForm.hideHistoric && skin !== 'icam-red') {
            <process-record
              [conceptObjectId]="conceptForm.concept?.conceptObjectId">
            </process-record>
          }
          @if (public && published) {
            <applicant-notifications
              [concept]="conceptForm.concept"
              (generateDocument)="generateDocument($event)">
            </applicant-notifications>
          }
          @if (conceptForm.productTypeId !== 4) {
            <attachments-template
              [typeFrom]="'concept'"
              [itemSelected]="conceptForm.concept"
              [concept]="conceptForm.concept"
              [lockComToManager]="lockComToManager"
              (launchAction)="launchActionGeneralConcept($event)">
            </attachments-template>
          }
          @if (!public) {
            <box-comments
              [conceptObjectId]="conceptForm.concept?.conceptObjectId"
              [readOnly]="conceptForm.concept?.sharedReadOnly">
            </box-comments>
          }@else if (skin !== 'icam-red' && isMonitoring) {
            <box-communication-channel
              [concept]="conceptForm.concept"
              [public]="public"
              [lockComToManager]="lockComToManager">
            </box-communication-channel>
          }
          @if (public && conceptForm.custom?.legalInfo) {
            <box-protection
              [data]="conceptForm.custom?.legalInfo"
              [type]="'legal'">
            </box-protection>
          }
          @if (public && conceptForm.custom?.extraInfo) {
            <box-protection
              [data]="conceptForm.custom?.extraInfo"
              [type]="'additional'">
            </box-protection>
          }
          @if (public && conceptForm.custom?.dataTreatment) {
            <box-protection
              [data]="conceptForm.custom?.dataTreatment"
              [type]="'protection'">
            </box-protection>
          }
        </div>
      }
      <div [ngClass]="conceptForm.concept?.poll || conceptForm.concept?.publicLite || conceptForm.designViewLanding === 2 ? 'concept-form__form-poll-landing-container' : 'concept-form__form-landing-container'">
        @if (descriptionField.description && conceptForm.concept?.poll) {
          <field-type-rich-text
            [field]="descriptionField"
            [concept]="concept"
            (openRelatedInfo)="openRelatedInfo($event)">
          </field-type-rich-text>
        }
        @if (conceptForm.viewConcept === 'steps' && conceptForm.filterContainers?.length > 1) {
          <concept-steps
            [concept]="conceptForm.concept"
            [filterContainers]="conceptForm.filterContainers"
            [changeStepsConcept]="conceptForm.changeStepsConcept">
          </concept-steps>
        }
        <div class="concept-form__form-body-container">
          @if(conceptForm.requiredFields){
            <div class="common-container__mandatory-obligatory-message-form">
              <span class="common-tag__mandatory-text-asterisk">*</span>
              <span class="common-tag__mandatory-label-text-obligatory-message"
                [afTranslate]="'common.required-fields'">
                _Campos obligatorios
              </span>
            </div>
          }
          <div class="concept-form__form-inner-container">
            @for (fieldContainer of conceptForm.concept?.fieldContainers; track mainIndex; let mainIndex = $index) {
              @if (fieldContainer.show && fieldContainer.showWithProperty && !fieldContainer.hidden && !(fieldContainer.private && conceptForm.userPublic) && !fieldContainer.hiddenInLandings) {
                <div [id]="'containerId-'+fieldContainer.fieldContainerId"
                  [hidden]="!fieldContainer.active && conceptForm.viewConcept === 'steps'"
                  class="concept-form__form-fields-container">
                  @if (!fieldContainer.showOnlySubcontainer) {
                    <div class="common-section-title__gs-container-primary">
                      @if (fieldContainer.references?.length) {
                        <tooltip-law
                          [references]="fieldContainer.references"
                          [type]="'group'"
                          [concept]="conceptForm.concept">
                        </tooltip-law>
                      }
                      @if (fieldContainer.relatedInfo?.length) {
                        <button
                          class="common-button__icon-sm-background"
                          pTooltip="{{'common.related-info'| afTranslate}}"
                          tooltipPosition="top"
                          (click)="openRelatedInfo(fieldContainer.relatedInfo)">
                          <i class="lf-icon-search-text common-icon__md"></i>
                        </button>
                      }
                      <!-- @if (fieldContainer.showInfo) {
                        <div class="concept-form__tooltip-info">
                          @for (reference of fieldContainer.references; track $index) {
                            <p class="concept-form__tooltip-inner-text">
                              {{reference.text}}
                            </p>
                          }
                        </div>
                      } -->
                      <div class="common-section-title__gs-item-container">
                        @if (fieldContainer.isHighlight) {
                          <i class="lf-icon-important common-icon__md common-section-title__gs-icon-important"></i>
                        }
                        <span class="common-section-title__gs-label-text">
                          {{fieldContainer.name}}
                        </span>
                      </div>
                    </div>
                  }
                  @if (!fieldContainer.showOnlySubcontainer) {
                    @for (field of fieldContainer.fields; track field) {
                      @if (field.show && field.showWithProperty && !fieldContainer.hiddenInLandings && !field.hiddenInLandings && !(field.private && conceptForm.userPublic && !(field.fieldTypeId === 'l-co' || field.fieldTypeId === 'l-sg'))) {
                        <field-item
                          [hidden]="field.hidden || (field.private && conceptForm.userPublic && (field.fieldTypeId === 'l-co' || field.fieldTypeId === 'l-sg'))"
                          [fieldInfo]="field"
                          [isPrivate]="fieldContainer.private"
                          [evaluatedConcepts]="conceptForm.concept?.evaluatedFields"
                          (evaluatedConceptChange)="changesInEvaluatedConcept($event)"
                          (evaluatedConceptChangeAdditional)="changesInEvaluatedConceptAdditional($event)"
                          (changeConceptFromField)="changeConceptFromField($event.template)"
                          [public]="public"
                          [concept]="conceptForm.concept"
                          [evaluationId]="evaluationId"
                          [conceptLocked]="conceptForm.conceptLocked || conceptForm.concept?.conceptNamedKey === 'Usuario'">
                        </field-item>
                      }
                    }
                  }
                  @for (subContainers of fieldContainer.subContainers; track $index) {
                    @if (subContainers.show && subContainers.showWithProperty && !subContainers.hidden && !(subContainers.private && conceptForm.userPublic)) {
                      <div [id]="'subContainerId-'+subContainers.fieldContainerId"
                        [hidden]="subContainers.hiddenInLandings || fieldContainer.hiddenInLandings"
                        [ngClass]="{ 'concept-form__form-subcontainer': !subContainers.hideContainer }">
                        @if (subContainers.multiple) {
                          <subcontainer-multiple
                            class="concept-form__form-fields-container"
                            [concept]="conceptForm.concept"
                            [subContainer]="subContainers"
                            [evaluatedMap]="conceptForm.evaluatedMap"
                            [subContainerMultiple]="conceptForm.concept?.subContainerMultiple"
                            [subcontainerDuplicated]="subContainers.subcontainerDuplicated"
                            [isPrivate]="(fieldContainer.private || subContainers.private)"
                            [evaluationProperties]="conceptForm.evaluationProperties"
                            [conceptLocked]="conceptForm.conceptLocked"
                            (evaluatedConceptChange)="changesInMultipleConcept($event)"
                            (saveBeforeCreate)="saveCreateConcept($event)">
                          </subcontainer-multiple>
                        }
                        @else if (!subContainers.poll) {
                          <div class="concept-form__form-fields-container">
                            @if (!subContainers.hideContainer) {
                              <div class="common-section-title__gs-container-secondary">
                                @if (subContainers.references?.length) {
                                  <tooltip-law
                                    [concept]="conceptForm.concept"
                                    [references]="subContainers.references"
                                    [type]="'group'">
                                  </tooltip-law>
                                }
                                @if (subContainers.relatedInfo?.length) {
                                  <button
                                    class="common-button__icon-sm-background"
                                    pTooltip="{{'common.related-info'| afTranslate}}"
                                    tooltipPosition="top"
                                    (click)="openRelatedInfo(subContainers.relatedInfo)">
                                    <i class="lf-icon-search-text common-icon__md">
                                    </i>
                                  </button>
                                }
                                <div class="common-section-title__gs-item-container">
                                  @if (subContainers.isHighlight) {
                                    <!-- [ngStyle]="{
                                        'background-color': conceptForm.custom?.color,
                                        'color': conceptForm.custom?.secondColor
                                    }" -->
                                    <i class="lf-icon-important common-icon__md common-section-title__gs-icon-important">
                                    </i>
                                  }
                                  <span
                                    [id]="'span-concept-form-sub-container-' + mainIndex + '-' + subContainers.fieldContainerId"
                                    class="common-section-title__gs-label-text">
                                    {{subContainers.name}}
                                  </span>
                                </div>
                              </div>
                            }
                            @for (subField of subContainers.fields; track $index) {
                              @if (subField.show && subField.showWithProperty && !fieldContainer.hiddenInLandings && !subField.hiddenInLandings && !subContainers.hiddenInLandings && !(subField.private && conceptForm.userPublic && !(subField.fieldTypeId === 'l-co' ||subField.fieldTypeId === 'l-sg'))) {
                                <field-item
                                  [hidden]="subField.hidden || (subField.private && conceptForm.userPublic && (subField.fieldTypeId === 'l-co' || subField.fieldTypeId === 'l-sg'))"
                                  [fieldInfo]="subField"
                                  [isPrivate]="fieldContainer.private || subContainers.private"
                                  [evaluatedConcepts]="conceptForm.concept?.evaluatedFields"
                                  (evaluatedConceptChange)="changesInEvaluatedConcept($event)"
                                  (evaluatedConceptChangeAdditional)="changesInEvaluatedConceptAdditional($event)"
                                  (changeConceptFromField)="changeConceptFromField($event.template)"
                                  [public]="public"
                                  [concept]="conceptForm.concept"
                                  [evaluationId]="evaluationId"
                                  [conceptLocked]="conceptForm.conceptLocked">
                                </field-item>
                              }
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>
        </div>
        <div
          [hidden]="!conceptForm.showSaveButtonIcamLanding"
          class="concept-form__footer">
          <div class="concept-form__footer-buttons-auto">
            @if (conceptForm.showSaveButtonsCustom && !conceptForm.concept?.publicLite) {
              <button (click)="clear()">
                <span class="common-button__text-title">
                  {{conceptForm.clearButton}}
                </span>
              </button>
            }
            @if (conceptForm.viewConcept === 'steps' && conceptForm.filterContainers?.length > 1) {
              @if (conceptForm.concept?.actualStep !== 1) {
                <button (click)="sendChangeStep(conceptForm.concept?.actualStep - 1)">
                  <span class="common-button__text-title"
                    [afTranslate]="'common.previous'">_Anterior
                  </span>
                </button>
              }
              @if (!conceptForm.concept?.actualStepIsLast && conceptForm.concept?.actualStep !== conceptForm.filterContainers?.length) {
                <button (click)="sendChangeStep(conceptForm.concept?.actualStep + 1)">
                  <span class="common-button__text-title"
                    [afTranslate]="'common.next'">_Siguiente
                  </span>
                </button>
              }
            }
            @if (conceptForm.showExitButtonCustom || (conceptForm.conceptLockedState && conceptForm.concept?.actualStepIsLast) || conceptForm.concept?.publicLite) {
              <button (click)="goBack()">
                <span class="common-button__text-title"
                  [afTranslate]="conceptForm.concept?.publicLite? 'common.return' : 'common.exit'">
                  _Volver / _Salir
                </span>
              </button>
            }
            @if (conceptForm.showSaveButtonsCustom && !conceptForm.concept?.publicLite && (conceptForm.viewConcept === 'general' || conceptForm.concept?.actualStep === conceptForm.filterContainers?.length || conceptForm.filterContainers?.length === 1 || conceptForm.concept?.actualStepIsLast)) {
              <button [disabled]="conceptForm.viewEditConcept || conceptForm.disabledSave"
                (click)="saveConcept()">
                <span class="common-button__text-title">
                  {{conceptForm.sendConceptButton}}
                </span>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
